import { css, cva } from '@/styled-system/css';

export const comboboxContentRecipe = cva({
  base: {
    borderRadius: 'obj.soft',
    backgroundColor: 'bg.elevated.mediumShadow',
    boxShadow: 'md',
    position: 'relative',
    overflow: 'auto',
    maxHeight: '360px',
  },
  variants: {
    dividers: {
      true: {
        '& [data-c11n-component="Combobox.Group"]:not(:last-child)': {
          borderBottomWidth: 'default',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Combobox.Group.border',
        },
      },
      false: {},
    },
  },
});

export const comboboxContentPositionerStyles = css.raw({
  zIndex: 'combobox',
});
